module.exports = __webpack_public_path__ + "static/media/FeedTime_web_2_preview.bb3977ea.jpg";